import {Component, OnInit} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PocketbaseService} from "../../services/pocketbase.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  username = new FormControl('');
  password = new FormControl('');
  constructor(private pocketbase:PocketbaseService, private router: Router) {
  }

  ngOnInit(): void {
        if (this.pocketbase.pb.authStore.isValid){
          this.router.navigate(["/"])
        }
    }
  login() {
    this.pocketbase.authUser(this.username.value??"",this.password.value??"")
      .then(e=>{
        this.error=!this.pocketbase.pb.authStore.isValid;
        if (!this.error){
          location.reload();
          this.router.navigate(["/"])
        }
      })

  }

  error = false;
}
